import AlarmBellIcon from '../../assets/icons/alarm-bell.svg?react';
import { AlarmTriggerState } from '../../gql/generated';
import { cn } from '../../utils/className';

export interface NotificationStateIconProps {
  state: AlarmTriggerState;
  className?: string;
}

/**
 * Leading bell icon shown per notification row: red when the alarm is
 * currently active (Triggered), muted grey once resolved.
 */
export function NotificationStateIcon({
  state,
  className,
}: NotificationStateIconProps) {
  const isActive = state === AlarmTriggerState.Triggered;

  return (
    <AlarmBellIcon
      className={cn(
        'h-3.5 w-3.5 shrink-0',
        isActive ? 'text-negative' : 'text-disabled',
        className
      )}
      aria-label={isActive ? 'Active' : 'Resolved'}
    />
  );
}
